module.exports = __webpack_public_path__ + "img/z (13).e80adccc.png";